import axios from 'axios'
import { CURRENT_CONFIG } from './config'
import { message } from 'ant-design-vue'
import router from '/@/router'
import { ELocalStorageKey, ERouterName, EUserType } from '/@/types/enums'
import {
  ensureValidToken,
  isAuthExemptUrl,
  refreshAccessToken,
} from '/@/utils/token-refresh'
export * from './type'

const REQUEST_ID = 'X-Request-Id'

function getAuthToken () {
  return localStorage.getItem(ELocalStorageKey.Token)
}

function redirectToLogin () {
  const flag: number = Number(localStorage.getItem(ELocalStorageKey.Flag))
  switch (flag) {
    case EUserType.Web:
      router.push(ERouterName.PROJECT)
      break
    case EUserType.Pilot:
      router.push(ERouterName.PILOT)
      break
  }
}

const instance = axios.create({
  // withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
  // timeout: 12000,
})

instance.interceptors.request.use(
  async config => {
    config.baseURL = CURRENT_CONFIG.baseURL
    if (isAuthExemptUrl(config.url)) {
      const token = getAuthToken()
      if (token) {
        config.headers[ELocalStorageKey.Token] = token
      }
    } else {
      const token = await ensureValidToken()
      if (token) {
        config.headers[ELocalStorageKey.Token] = token
      }
    }
    // config.headers[REQUEST_ID] = uuidv4()
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

instance.interceptors.response.use(
  response => {
    console.info('URL: ' + response.config.baseURL + response.config.url, '\nData: ', response.data, '\nResponse:', response)
    if (response.data.code && response.data.code !== 0) {
      message.error(response.data.message)
    }
    return response
  },
  async err => {
    const requestId = err?.config?.headers && err?.config?.headers[REQUEST_ID]
    if (requestId) {
      console.info(REQUEST_ID, '：', requestId)
    }
    console.info('url: ', err?.config?.url, `【${err?.config?.method}】 \n>>>> err: `, err)

    // @See: https://github.com/axios/axios/issues/383
    if (!err.response || !err.response.status) {
      message.error('The network is abnormal, please check the backend service and try again')
      return Promise.reject(err)
    }

    const status = err.response.status
    const config = err.config
    const url = config?.url || ''

    if (status === 401 && config && !isAuthExemptUrl(url) && !config._retry) {
      config._retry = true
      const newToken = await refreshAccessToken()
      if (newToken) {
        config.headers[ELocalStorageKey.Token] = newToken
        return instance(config)
      }
      redirectToLogin()
      return Promise.reject(err)
    }

    if (status !== 200) {
      message.error(`ERROR_CODE: ${status}`)
    }
    if (status === 401) {
      redirectToLogin()
    }

    return Promise.reject(err)
  },
)

export default instance
